export default function Badge({
    children,
    variant = 'primary',
    size = 'md',
    pill = false,
    dot = false,
    icon = null,
    className = ''
}) {
    const variants = {
        primary: 'bg-primary',
        secondary: 'bg-secondary',
        success: 'bg-success',
        danger: 'bg-danger',
        warning: 'bg-warning text-dark',
        info: 'bg-info',
        light: 'bg-light text-dark',
        dark: 'bg-dark',
        'primary-subtle': 'bg-primary-subtle text-primary',
        'success-subtle': 'bg-success-subtle text-success',
        'danger-subtle': 'bg-danger-subtle text-danger',
        'warning-subtle': 'bg-warning-subtle text-warning',
        'info-subtle': 'bg-info-subtle text-info',
    };

    const sizes = {
        sm: 'badge-sm',
        md: '',
        lg: 'badge-lg',
    };

    if (dot) {
        return (
            <span className="d-inline-flex align-items-center gap-2">
                <span
                    className={`rounded-circle ${variants[variant]}`}
                    style={{ width: '8px', height: '8px' }}
                />
                {children}
            </span>
        );
    }

    return (
        <span className={`badge ${variants[variant]} ${sizes[size]} ${pill ? 'rounded-pill' : ''} ${className}`}>
            {icon && <i className={`bi ${icon} me-1`}></i>}
            {children}
        </span>
    );
}
